import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import * as Sentry from '@sentry/react';

import rootReducer from './reducers';
import { USER_AUTHENTICATION_SUCCESS, CONTACTLESS_AUTHENTICATION_SUCCESS } from './services/Authentication/actions';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action) => {
    if (action.type === USER_AUTHENTICATION_SUCCESS || action.type === CONTACTLESS_AUTHENTICATION_SUCCESS) {
      // Prevent proliferation of tokens to Sentry
      return {
        ...action,
        payload: {
          ...action.payload,
          token: 'hidden',
        },
      };
    }

    return action;
  },
  attachReduxState: false,
});

export const history = createBrowserHistory();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }), // Serializing and immutabilityCheck removed since using Immutable.JS
  enhancers: [sentryReduxEnhancer],
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
